import { Button } from 'reactstrap';

const SelectionButton = ({ selected, as = Button, ...props }) => {
  const Component = as;
  return (
    <Component
      color={selected ? 'primary' : 'secondary'}
      outline={!selected}
      {...props}
    />
  );
};

export default SelectionButton;
